'use client';

import { useEffectOnce } from '@carvana/merch-react-hooks';
import Composer from '@/common/Composer';
import VdpComposerSlot from '@/vdp/ComposerUi/VdpComposerSlot';
import VdpComposerUpperSlot from '@/vdp/ComposerUi/VdpComposerUpperSlot';
import { useTrackEvent } from '~/context/common/AnalyticsProvider';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';
import usePrimaryCtaButtonCopy from '~/hooks/vdp/selectors/usePrimaryCtaButtonCopy';
import usePrimaryCtaButtonState from '~/hooks/vdp/selectors/usePrimaryCtaButtonState';
import useSecondaryCtaButtonCopy from '~/hooks/vdp/selectors/useSecondaryCtaButtonCopy';
import useShowComposerPendingFooter from '~/hooks/vdp/selectors/useShowComposerPendingFooter';
import useTextCtaButtonCopy from '~/hooks/vdp/selectors/useTextCtaButtonCopy';

export default function VdpComposerUi() {
  const showComposerTreatment = useShowComposerTreatment();
  const showPendingFooter = useShowComposerPendingFooter();
  const trackEvent = useTrackEvent();
  const { isLoading } = usePrimaryCtaButtonState();
  const primaryCtaText = usePrimaryCtaButtonCopy();
  const secondaryCtaText = useSecondaryCtaButtonCopy();
  const textCtaText = useTextCtaButtonCopy();
  const chipsOffered = [secondaryCtaText, textCtaText, primaryCtaText].filter(
    (text): text is string => Boolean(text)
  );

  useEffectOnce(
    () => {
      trackEvent('composer_shell_loaded', { chipsOffered, page: 'vdp' });
    },
    [chipsOffered, trackEvent],
    showComposerTreatment && !isLoading
  );

  if (!showComposerTreatment) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40">
      <Composer
        inputPlaceholder="Ask about this car or keep searching"
        strongBg={showPendingFooter}
        page="vdp"
        slot={<VdpComposerSlot />}
        upperSlot={showPendingFooter ? <VdpComposerUpperSlot /> : undefined}
      />
    </div>
  );
}
